/**
 * 공용 테마(`@into/into-common-theme`)에 없는 디자인 색
 *
 * 팔레트에 토큰이 생기면 해당 항목을 지우고 토큰으로 교체 사용
 */
export const EXTRA_COLORS = {
    /**
     * 짙은 녹색 — 테마의 `colors_green`(#2BC97B)과 **다른 값**
     *
     * 엑셀 액션(양식 다운로드 · 파일 업로드 · Excel파일로 저장)과 [대량] 뱃지가 함께 사용
     */
    GREEN_DEEP: '#00733B',
};
